import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("neoventra_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // verify on mount if token exists but no user
    const token = localStorage.getItem("neoventra_token");
    if (token && !user) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("neoventra_user", JSON.stringify(r.data));
      }).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("neoventra_token", data.token);
      const u = { id: data.id, email: data.email, name: data.name, role: data.role };
      localStorage.setItem("neoventra_user", JSON.stringify(u));
      setUser(u);
      return { ok: true, user: u };
    } catch (e) {
      return { ok: false, error: formatErr(e) };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("neoventra_token");
    localStorage.removeItem("neoventra_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
